const PARIS_FMT = new Intl.DateTimeFormat("fr-FR", {
  timeZone: "Europe/Paris",
  year: "numeric", month: "2-digit", day: "2-digit",
  hour: "2-digit", minute: "2-digit", second: "2-digit",
});

export const toParisTime = (utcStr) => {
  if (!utcStr) return "—";
  try {
    // Syrinix stocke en UTC sans suffixe 'Z' — forcer l'interprétation UTC
    const s = /[Z+]/.test(utcStr) ? utcStr : utcStr + "Z";
    return PARIS_FMT.format(new Date(s));
  }
  catch { return utcStr; }
};

export const fmtAnswerTime = (str) => {
  if (!str) return "—";
  try { return PARIS_FMT.format(new Date(str.replace(" ", "T"))); }
  catch { return str; }
};

/* Durée lisible entre deux timestamps UTC, ex. "4m 16s" — null si invalide */
export const fmtDuration = (start, end) => {
  if (!start || !end) return null;
  const toMs = s => new Date(/[Z+]/.test(s) ? s : s + "Z").getTime();
  const sec = Math.round((toMs(end) - toMs(start)) / 1000);
  if (isNaN(sec) || sec < 0) return null;
  const m = Math.floor(sec / 60), r = sec % 60;
  return m > 0 ? `${m}m ${r}s` : `${r}s`;
};
